export enum InfoBannerLevel {
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
  Error = 'error',
  Danger = 'danger',
  Trust = 'trust',
}

export enum InfoBannerScreen {
  CurrentUserReviews = 'current_user_reviews',
  TermsAndConditions = 'terms_and_conditions',
}
